import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchMetaAdsStatus, saveMetaAdsConfig, syncMetaAds, testMetaAdsConfig } from '@/api/meta-ads';
import type { SaveMetaAdsRequest, TestMetaAdsRequest } from '@/types/meta-ads';

/**
 * Módulo 11 — Meta Ads: estado, guardado de credenciales, diagnóstico y sincronización manual.
 *
 * La sincronización escribe el gasto de los anuncios, así que al terminar se invalida TODO: los
 * reportes de CPA y la pantalla de Campañas leen esos números y quedarían viejos. Es una acción de
 * ADMIN y poco frecuente: invalidar de más aquí no cuesta nada.
 *
 * «Probar credenciales» (`probar`) NO escribe nada —ni en Meta ni en la base—, así que no invalida
 * cachés: solo devuelve el veredicto para pintarlo.
 */
export function useMetaAds(tenantId: string | null) {
  const queryClient = useQueryClient();

  const status = useQuery({
    queryKey: ['meta-ads', tenantId],
    queryFn: () => fetchMetaAdsStatus(tenantId ?? ''),
    enabled: Boolean(tenantId),
  });

  const guardar = useMutation({
    mutationFn: (payload: SaveMetaAdsRequest) => saveMetaAdsConfig(tenantId ?? '', payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['meta-ads'] });
    },
  });

  const sincronizar = useMutation({
    mutationFn: (dias?: number) => syncMetaAds(tenantId ?? '', dias ? { dias } : {}),
    onSuccess: () => {
      void queryClient.invalidateQueries();
    },
  });

  const probar = useMutation({
    mutationFn: (payload: TestMetaAdsRequest) => testMetaAdsConfig(tenantId ?? '', payload),
  });

  return { status, guardar, sincronizar, probar };
}
